import axios from 'axios';

// 获取新闻列表
export async function newsList(newsType, pageNum = 1, keyword, isOut) {
  const formData = new FormData();
  formData.append('news_type', newsType);
  formData.append('page', pageNum);
  if(keyword){
    formData.append('keyword', keyword);
  }
  const result = axios.post('/api/Company/getPageList', formData).catch(result => result)
  return result
}

// 获取热门新闻
export async function getHotNewsList() {
  const result =  axios.get('api/Company/getHotNewsList')
  return result
}